import React, {useState}  from 'react';
import Modal from '../modal/modal.jsx';
import LibraryComponent from "../../../components/library/library";


const CourseSelectModal = ({title, courses, onItemSelected, onRequestClose}) => {

    const items = courses.map(item=>({
        extensionId: item.id,
        name: item.name,
        rawURL: window.config.staticURL + '/cover/course/' + item.id + '.png',
        //iconRawURL: "/static/appstore.png",
        //insetIconURL: item.studying ? require('./studying.png') : undefined,
        featured: true,
        //disabled: false,
        //cornerText: window.L('teach.course.locked'),
        //description: item.desc,

    }));
    return (
        <LibraryComponent
            id="courseSelectLibrary"
            title={title || window.L("teach.class.selectCourses")}
            data={items}
            onItemSelected={onItemSelected}
            onRequestClose={onRequestClose}
            />
    );
};

export default CourseSelectModal;
